import { createFileRoute } from '@tanstack/react-router'
import { Pacientes } from '@/features/pacientes/Pacientes'

export const Route = createFileRoute('/_app/app/pacientes')({
  staticData: { crumb: { label: 'Pacientes' } },
  component: Pacientes,
})
